import { render, staticRenderFns } from "./ExchangeDetail.vue?vue&type=template&id=332ad996&scoped=true"
import script from "./ExchangeDetail.vue?vue&type=script&lang=js"
export * from "./ExchangeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ad996",
  null
  
)

export default component.exports